module.exports = __webpack_public_path__ + "static/img/6areaB_3.88547ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/6areaB_3.png
// module id = 1206
// module chunks = 1